import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1d82bf56")
const _hoisted_1 = { class: "my-page-container" }
const _hoisted_2 = { class: "farmer-wrap" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "phone" }
const _hoisted_6 = { class: "address" }
const _hoisted_7 = { class: "bottom-tag" }
const _hoisted_8 = { class: "farmer-bottom" }
const _hoisted_9 = { class: "user-bottom" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell = _resolveComponent("van-cell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "farmer-info",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toMyInfo && _ctx.toMyInfo(...args)))
      }, [
        _createVNode(_component_van_image, {
          class: "left",
          src: _ctx.userData.imgs?_ctx.userData.imgs[0].url:'https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png',
          fit: "cover"
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.userData.farmerName), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.userData.phoneNumber), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.userData.addressInfo), 1)
        ]),
        _createVNode(_component_van_icon, {
          class: "more",
          size: "20",
          color: "#666",
          name: "arrow"
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData.types, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              style: _normalizeStyle('background:' + item.color),
              key: item.id
            }, _toDisplayString(item.name), 5))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_van_cell, {
        onClick: _ctx.onResource,
        title: "我的资源",
        "is-link": ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_van_cell, {
        onClick: _ctx.onFeedback,
        title: "吐个槽",
        "is-link": ""
      }, null, 8, ["onClick"])
    ])
  ]))
}